/* 
 * Thanks: Ömer Faruk Karabulut (http://yakalasam.com/)
 */

t_jp.l = {
    'Close without saving?': 'Kaydetmeden çıkış yap?',
    'You have made a change to the translation. Are you sure you want to discard it?': 'Çeviride değişlikler yaptınız. Kaydetmeden çıkış yapmak istediğinizden emin misiniz?',
    'History': 'Geçmiş',
    'Loading...': 'Yükleniyor...',
    'Translated': 'Çevirildi',
    'By': 'Çeviren:',
    'At': 'Çevirildiği Sistem:',
    'google': 'google',
    'bing': 'bing',
    'apertium': 'apertium',
    'manual translation': 'manuel çeviri',
    'bing suggest': 'bing tavsiyesi',
    'google suggest': 'google tavsiyesi',
    'apertium suggest': 'apertium tavsiyesi',
    'Edit Translation': 'Çeviriyi Düzenle',
    'Original text': 'Orjinal yazı',
    'read alternate translations': 'alternatif çevirileri oku ',
    'previous translation': 'geçmiş çeviri',
    'find on page': 'sayfada aroma yap',
    'next translation': 'gelecek çeviri',
    'Translate to': 'Şu dile çevir',
    'view translation log': 'çeviri log verilerini görüntüle',
    'virtual keyboard': 'sanal klavye',
    'approve translation': 'çeviriyi kabul et',
    'delete': 'sil',
    'Discard': 'İptal et',
    'Cancel': 'Vazgeç'
};